import styled from "styled-components";
import { AikaDate } from "utils/AikaDate";
import { range } from "lodash";
import { MIN_BLOCK } from "../utils";
import useCurrentMinute from "hooks/useCurrentMinute";

const Container = styled.div`
  flex: 1;
  position: relative;
  padding-bottom: 150px;
`;

const BlocksContainer = styled.div`
  position: relative;
`;

const Slot = styled.div`
  border-bottom: 2px solid ${(props) => props.theme.colors.grey1};

  &:last-child {
    border-bottom: 0;
  }
`;

const ColumnHeader = styled.div<{ isToday: boolean }>`
  height: 60px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  user-select: none;
  pointer-events: none;
  border-bottom: 2px solid ${(props) => props.theme.colors.grey1};
  color: ${(props) =>
    props.isToday ? props.theme.colors.primary : props.theme.colors.body};
`;

type DayColumnMouseEvent = {
  slot: number;
};

export type DayColumnProps = {
  day: AikaDate;
  unitHeight: number;
  start: number;
  end: number;
  children?: React.ReactNode;
  onClick: (ev: DayColumnMouseEvent) => void;
};

const TimeNeedle = styled.div`
  z-index: 500;
  height: 3px;
  width: calc(100% - 2px);
  position: absolute;
  pointer-events: none;
  background-color: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.body};
  border-radius: 2px;
  left: 2px;
  transform: translateY(-2px);
  &:before {
    content: "";
    width: 12px;
    height: 12px;
    background-color: ${(props) => props.theme.colors.background};
    border: 1px solid ${(props) => props.theme.colors.body};
    display: block;
    position: absolute;
    border-radius: 50%;
    top: -5px;
    left: -8px;
  }
`;

export const DayColumn = ({
  day,
  start,
  end,
  unitHeight,
  onClick,
  children,
}: DayColumnProps) => {
  const currentMinute = useCurrentMinute();

  const showNeedle =
    day.isToday() && currentMinute > start && currentMinute < end;

  return (
    <Container>
      <ColumnHeader isToday={day.isToday()}>
        {day.getDay()}
        <br />
        {day.toString()}
      </ColumnHeader>
      <BlocksContainer>
        {showNeedle && (
          <TimeNeedle
            style={{ top: ((currentMinute - start) / MIN_BLOCK) * unitHeight }}
          />
        )}
        {children}
        {range(start, end + 1, MIN_BLOCK).map((x) => (
          <Slot
            style={{ height: unitHeight }}
            onClick={() => onClick({ slot: x })}
          />
        ))}
      </BlocksContainer>
    </Container>
  );
};
